import type { ReactNode } from "react";
import SiteLayout from "./SiteLayout";
import SideNav from "./SideNav";
import Breadcrumb, { type Crumb } from "./Breadcrumb";

interface PageShellProps {
  crumbs: Crumb[];
  active?: string;
  children: ReactNode;
}

export default function PageShell({ crumbs, active, children }: PageShellProps) {
  return (
    <SiteLayout>
      <div className="mx-auto flex w-full max-w-[1280px] flex-col gap-6 px-4 py-6 md:px-6 md:py-8 lg:flex-row lg:gap-8">
        <SideNav active={active} />
        <div className="min-w-0 flex-1">
          <div className="mb-5">
            <Breadcrumb items={crumbs} />
          </div>
          {children}
        </div>
      </div>
    </SiteLayout>
  );
}